<template>
  <!--begin::Card-->
  <div class="card card-custom">
    <!--begin::Header-->
    <div class="card-header py-3">
      <div class="card-title align-items-start flex-column">
        <h3 class="card-label font-weight-bolder text-dark">Actualizar Contrase&ntilde;a</h3>
        <span class="text-muted font-weight-bold font-size-sm mt-1"
          >Actualizar la contrase&ntilde;a para tu cuenta</span
        >
      </div>
      <div class="card-toolbar">
      </div>
    </div>
    <!--end::Header-->
    <!--begin::Form-->
    <form class="form" id="kt_password_change_form">
      <div class="card-body">
        <!--begin::Alert-->
        <div
          class="alert alert-custom alert-light-danger fade show mb-10  d-none"
          role="alert"
        >
          <div class="alert-icon">
            <span class="svg-icon svg-icon-3x svg-icon-danger">
              <!--begin::Svg Icon | path:assets/media/svg/icons/Code/Info-circle.svg-->
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                version="1.1"
              >
                <g
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <rect x="0" y="0" width="24" height="24" />
                  <circle fill="#000000" opacity="0.3" cx="12" cy="12" r="10" />
                  <rect
                    fill="#000000"
                    x="11"
                    y="10"
                    width="2"
                    height="7"
                    rx="1"
                  />
                  <rect
                    fill="#000000"
                    x="11"
                    y="7"
                    width="2"
                    height="2"
                    rx="1"
                  />
                </g>
              </svg>
              <!--end::Svg Icon-->
            </span>
          </div>
          <div class="alert-text font-weight-bold">
            Configure user passwords to expire periodically. Users will need
            warning that their passwords are going to expire, <br />or they
            might inadvertently get locked out of the system!
          </div>
          <div class="alert-close">
            <button
              type="button"
              class="close"
              data-dismiss="alert"
              aria-label="Close"
            >
              <span aria-hidden="true">
                <i class="ki ki-close"></i>
              </span>
            </button>
          </div>
        </div>
        <!--end::Alert-->
        <div class="form-group row">
          <label class="col-xl-3 col-lg-3 col-form-label text-alert"
            >Contrase&ntilde;a actual</label
          >
          <div class="col-lg-9 col-xl-6">
            <input
              type="password"
              class="form-control form-control-lg form-control-solid mb-2"
              value=""
              placeholder="Ingresa tu contraseña actual"
              name="current_password"
              ref="current_password"
              v-model="datosPass.antiguoPass"
            />
            <a href="#" class="text-sm font-weight-bold d-none">Forgot password ?</a>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-xl-3 col-lg-3 col-form-label text-alert"
            >Nueva contrase&ntilde;a</label
          >
          <div class="col-lg-9 col-xl-6">
            <input
              type="password"
              class="form-control form-control-lg form-control-solid"
              value=""
              placeholder="Ingresa tu nueva contraseña"
              name="new_password"
              ref="new_password"
               v-model="datosPass.nuevoPass"
            />
          </div>
        </div>
        <div class="form-group row">
          <label class="col-xl-3 col-lg-3 col-form-label text-alert"
            >Validar contrase&ntilde;a</label
          >
          <div class="col-lg-9 col-xl-6">
            <input
              type="password"
              class="form-control form-control-lg form-control-solid"
              value=""
              placeholder="Verifica nueva contraseña"
              name="verify_password"
              ref="verify_password"
              v-model="datosPass.nuevoPassConfirm"
            />
          </div>
        </div>
      </div>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          type="submit"
          color="primary"
          class="mb-2 float-right"
          :elevation="0" 
          @click="restablecerContrasenia()"
          ref="kt_save_changes"
          :loading="btnResetPassLoading"
        >
          Actualizar
        </v-btn>
        <v-btn 
          type="reset" 
          class="mb-2 float-right grey lighten-5" 
          color="grey lighten-5"
          elevation="0"
          @click="cancel()">
          Cancelar
        </v-btn>
      </v-card-actions>
    </form>
    <!--end::Form-->

    <!--Inicio:: Snack alert-->
    <SnackAlert ref="snackalert"></SnackAlert>
    <!-- Fin:: Snack alert-->

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SnackAlert from '@/view/content/SnackAlert.vue';

import { GET_CURRENT_USER } from "@/core/services/store/auth.module";
import { RESTABLECER_PASS_USUARIO_PERFIL } from "@/core/services/store/usuarios/usuario.module";

import KTUtil from "@/assets/js/components/util";

import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";


// FormValidation plugins
import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";
import SubmitButton from "@/assets/plugins/formvalidation/dist/es6/plugins/SubmitButton";
//import Swal from "sweetalert2";

export default {
  name: "ChangePassword",
  components: {
    SnackAlert
  },
  data() {
    return {
      password: "",
      status: "",
      valid: true,
      btnResetPassLoading:false,
      datosUsuario:[],
      datosPass:{
        idUsuario: 0,
        correoUsuario: '',
        antiguoPass:'',
        nuevoPass: '',
        nuevoPassConfirm:'',
        usuarioActualizacion: ''
      },
    };
  },
  mounted() {
    const password_change_form = KTUtil.getById("kt_password_change_form");
    //var curr_password = this.currentUser.password;

    this.fv = formValidation(password_change_form, {
      fields: {
        /*current_password: {
          validators: {
            notEmpty: {
              message: "Current password is required"
            },
            identical: {
              compare: function() {
                return curr_password;
              },
              message: ""
              
            }
          }
        },*/
        new_password: {
          validators: {
            notEmpty: {
              message: "La nueva contraseña es obligatoria"
            }
          }
        },
        verify_password: {
          validators: {
            notEmpty: {
              message: "Congirmación de contraseña es obligatorio"
            },
            identical: {
              compare: function() {
                return password_change_form.querySelector(
                  '[name="new_password"]'
                ).value;
              },
              message: "La contraseña y la confirmación no coinciden"
            }
          }
        }
      },
      plugins: {
        trigger: new Trigger(),
        bootstrap: new Bootstrap(),
        submitButton: new SubmitButton()
      }
    });
  },
  methods: {

      /**
       * Obtener información del usuario
       */
      async getUserInfo(){
        await this.$store
          .dispatch(GET_CURRENT_USER)
          .then(res => {
            if(res.status===200){
              this.datosUsuario = this.$store.state.auth.currentUser;
            }
            //console.log(this.datosUsuario)
          })
          .catch(()=>{
            this.$router.push({ name: "login" });
          })
      },

      /**
      * Restablecer la contraseña del usuario master institucion
      */
      restablecerContrasenia(){

       // console.log(this.datosUsuario)
          this.datosPass.idUsuario = this.datosUsuario.id;
          this.datosPass.correoUsuario = this.datosUsuario.correoUsuario;
          this.datosPass.usuarioActualizacion= this.datosUsuario.id.toString();
      
          this.btnResetPassLoading = true;
          this.$store
          .dispatch(RESTABLECER_PASS_USUARIO_PERFIL, this.datosPass)
          .then(res => {
              if(res.status==200){
                  this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.message);
                  this.dialogResetPass = false;
              } else {
                  this.$refs.snackalert.SnackbarShow('warning', 'Alerta', `Ha ocurrido un error durante la actualización.`);
              }
              this.btnResetPassLoading = false;
          })
          .catch(err => {
              this.$refs.snackalert.SnackbarShow('warning', 'Alerta', `Ha ocurrido un error inesperado, por favor, póngase en contacto con el administrador del sistema. REF: ${err}`);
              this.btnResetPassLoading = false;
          });


      },

    /*save() {
      this.fv.validate();

      this.fv.on("core.form.valid", () => {
        var password = this.$refs.new_password.value;
        const submitButton = this.$refs["kt_save_changes"];

        // set spinner to submit button
        submitButton.classList.add("spinner", "spinner-light", "spinner-right");

        // dummy delay
        setTimeout(() => {
          // send update request
          this.$store
            .dispatch(UPDATE_PASSWORD, { password })
            // go to which page after successfully update
            .then(() => this.$router.push({ name: "dashboard" }));

          submitButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
        }, 2000);
      });

      this.fv.on("core.form.invalid", () => {
        Swal.fire({
          title: "",
          text: "Please, provide correct data!",
          icon: "error",
          confirmButtonClass: "btn btn-secondary"
        });
      });
    },*/
    cancel() {
      this.fv.resetForm();
      this.$refs.current_password.value = "";
      this.$refs.new_password.value = "";
      this.$refs.verify_password.value = "";
    }
  },
  created(){
    this.getUserInfo();
  },
  computed: {
    ...mapGetters(["currentUser"])
  }
};
</script>
